import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';

const ButtonAction = ({ icon, text, onClick, id, disabled }) => {
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      border-color: ${colorStatus} !important;
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
    }
  `;
  return (
    <div className="d-flex flex-direction-column align-items-center mx-2">
      <Stylescal>
        <Button.Ripple
          disabled={disabled}
          id={id}
          color="danger"
          className="btn-icon rounded-circle"
          onClick={onClick}
        >
          {icon}
        </Button.Ripple>
      </Stylescal>
      {text}
    </div>
  );
};
ButtonAction.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.any.isRequired,
  text: PropTypes.string.isRequired,
};

export default ButtonAction;
